<script setup>
import FormModal from "@Components/Modal/FormModal.vue";
import { PrimaryButton } from "@Components/Button";
import { getBlock } from "@Utils/project";
import { ref, computed, watch } from "vue";
import { useI18n } from "vue-i18n";
import _cloneDeep from "lodash/cloneDeep";
import { DialogTitle } from "@headlessui/vue";
import TextBlockParameters from "./TextBlockParameters.vue";

const model = defineModel();

const { t: __ } = useI18n();

const modal = ref();
const form = ref();

const block = computed(() => {
    if (model.value) {
        return getBlock(model.value.block);
    }
});

const save = () => {
    model.value.settings = _cloneDeep(form.value);
    hide();
};

const show = () => {
    modal.value.show();
};

const hide = () => {
    modal.value.hide();
};

watch(model, (value) => {
    if (value !== undefined) {
        form.value = _cloneDeep(value.settings);
    }
});

defineExpose({ show, hide });
</script>

<template>
    <FormModal ref="modal" @submit="save" max-height="80vh">
        <template #header>
            <div class="flex flex-none justify-between items-center px-4 py-4 border-b border-gray-300 dark:border-gray-800 lg:px-8 sm:px-6">
                <DialogTitle class="text-lg font-semibold leading-6 text-gray-900 dark:text-white">{{ __("Paramètres du block") }}</DialogTitle>
            </div>
        </template>
        <template #body>
            <TextBlockParameters v-if="block.key === 'text'" v-model="form" />
        </template>
        <template #actions>
            <div class="flex justify-end items-center">
                <PrimaryButton type="submit" :z="1">
                    {{ __("Sauvegarder") }}
                </PrimaryButton>
            </div>
        </template>
    </FormModal>
</template>
